import { render, staticRenderFns } from "./commercial.vue?vue&type=template&id=617f1456"
import script from "./commercial.vue?vue&type=script&lang=js"
export * from "./commercial.vue?vue&type=script&lang=js"
import style0 from "./commercial.vue?vue&type=style&index=0&id=617f1456&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports